export default __webpack_public_path__ + "static/media/admin-step1.f7928107.gif";